module.exports = __webpack_public_path__ + "static/annual-report-2019-20-1cec1f817f81fff35fee32538505d481.pdf";